import React,{useEffect, useRef} from "react";
import { motion } from "framer-motion";
import BreadCrumb from "../Components/BreadCrumb";
import bgImg from '../Images/csr-breadcrumb.webp';
import Gallery from "../Components/Gallery";
import { csrActivity, csrGalleryData, envCommitments } from "../Data";
import Cta from "../Components/Cta";
import Certificates from "../Components/Certificates";
import ContactSection from "../Components/ContactSection";
import heroImg from '../Images/csr-intro.webp'
import heroImg2 from '../Images/csr-hero-2.webp'
import sustainabilityIcon1 from '../Images/sustainable-1.png'
import sustainabilityIcon2 from '../Images/sustainable-2.png'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import organizationSchema from "../Schema/OrganizationSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import aboutPageSchema from "../Schema/AboutPageSchema";

const Csr=()=>{
    useEffect(() => {
                document.title =
                  "CSR & Sustainability Initiatives | Iris Impulse India Pvt. Ltd.";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Learn how Iris Impulse India Pvt. Ltd. supports communities and the environment through corporate social responsibility and sustainability projects. Learn now!"
                  );
                }
            
                 const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://irisimpulse.com/about-us/csr-sustainability");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "CSR & Sustainability Initiatives | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Learn how Iris Impulse India Pvt. Ltd. supports communities and the environment through corporate social responsibility and sustainability projects. Learn now!"
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://irisimpulse.com/about-us/csr-sustainability");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/csr.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "CSR & Sustainability Initiatives | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Learn how Iris Impulse India Pvt. Ltd. supports communities and the environment through corporate social responsibility and sustainability projects. Learn now!"
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/csr.webp"
                );
              }
              }, []);

    const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" }
  }
}

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2
    }
  }
};

const fadeLeft = {
  hidden: { opacity: 0, x: -60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.9, ease: "easeOut" }
  }
};

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const cardAnim = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const prevRef = useRef(null);
  const nextRef = useRef(null);

const organizationData = organizationSchema();
const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "About Us",
      url: "https://irisimpulse.com/about-us"
    },
    {
      name: "CSR & Sustainability at Iris Impulse",
    },
  ],
});
const aboutPageData = aboutPageSchema({
  url: "https://irisimpulse.com/about-us/csr-sustainability",
  title: "CSR & Sustainability Initiatives | Iris Impulse India Pvt. Ltd.",
  description:
    "Learn how Iris Impulse India Pvt. Ltd. supports communities and the environment through corporate social responsibility and sustainability projects. Learn now!",
  image: "https://irisimpulse.com/Images/csr.webp",
});
    return(
        <>

      <SchemaMarkup data={organizationData} />
      <SchemaMarkup data={breadcrumbData} />
      <SchemaMarkup data={aboutPageData} />

          <BreadCrumb
  title="CSR & Sustainability at Iris Impulse" 
  bgImage={bgImg} 
/>

      {/**RESPONSIBLE BUISNESS PRACTICE SECTION */}
      <section className="video-section container research-intro">
  

  <motion.div
    className="video-wrapper"
    variants={fadeLeft}
    initial="hidden"
    whileInView="visible"
   iewport={{ once: true, margin: "-50px" }}
  >
    <img src={heroImg} alt="Our Pledge to Responsible Business Practices | Iris Impulse India Pvt. Ltd." />
  </motion.div>


  <motion.div
    className="mining-card"
    variants={container}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    <div className="mining-card-inner">

    <motion.h2 className="section-heading" variants={fadeUp}>
   Our Pledge to Responsible Business Practices
    </motion.h2>

    <motion.p className="section-text" variants={fadeUp}>
     At <b className="bold">Iris Impulse India Pvt. Ltd.</b>, Gandhidham, Kutch, Gujarat, India, we are deeply committed to responsible and sustainable business practices that balance growth with environmental and social responsibility. From eco-conscious mining and energy-efficient operations to water conservation, waste management, and renewable energy initiatives, we strive to minimize our environmental footprint at every stage of our operations. Our Corporate Social Responsibility (CSR) programs focus on uplifting local communities through education, health, skill development, and infrastructure support, ensuring long-term socio-economic benefits. By embedding sustainability and ethics into all aspects of our business, <b className="bold">Iris Impulse India Pvt. Ltd.</b> fosters trust, integrity, and shared value, delivering high-quality mineral solutions while positively impacting society and the environment.
    </motion.p>
    <motion.p className="section-text" variants={fadeUp}>
  In addition to our operational sustainability efforts, <b className="bold">Iris Impulse India Pvt. Ltd.</b> actively promotes a culture of safety, transparency, and continuous improvement across the organization. We prioritize employee well-being through regular training programs, safe working environments, and ethical workplace practices that encourage growth and collaboration. Our focus on innovation and responsible resource utilization enables us to deliver reliable mineral solutions that meet international quality standards while preserving natural resources for future generations. Through strong partnerships with stakeholders, environmentally responsible technologies, and community-centered initiatives, we continue to strengthen our commitment toward sustainable industrial development and long-term global responsibility.
</motion.p>
  </div>
  </motion.div>

</section>

      {/**CSR ACTVITIES SECTION */}
      <section className="mining-cards csr-section">
  <div className="container">

    {/* HEADING */}
    <motion.h2
      className="section-heading"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7 }}
      viewport={{ once: true }}
    >
Empowering Communities Through CSR Initiatives
    </motion.h2>

    <div className="mining-cards-slider">
      <div ref={prevRef} className="custom-arrow prev-arrow">
        <motion.span
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          whileHover={{ scale: 1.1 }}
        >
          &#10094;
        </motion.span>
      </div>

      <div ref={nextRef} className="custom-arrow next-arrow">
        <motion.span
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          whileHover={{ scale: 1.1 }}
        >
          &#10095;
        </motion.span>
      </div>

      <Swiper
        modules={[Navigation, Pagination]}
        slidesPerView={1}
        loop={true}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current
        }}
        pagination={{
          clickable: true,
          el: ".mining-pagination"
        }}
        className="mining-swiper"
      >
        {csrActivity.map((item) => (
          <SwiperSlide key={item.id}>
            <motion.div
              className="mining-slide"
              initial={{ opacity: 0, scale: 0.98 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
            >

              {/* IMAGE */}
              <div className="mining-image">
                <motion.img
                  src={item.img}
                  alt={`${item.cardTitle} | Iris Impulse India Pvt. Ltd.`}
                  initial={{ scale: 1.05 }}
                  whileInView={{ scale: 1 }}
                  transition={{ duration: 1.2 }}
                />
              </div>

              {/* CARD */}
              <motion.div
                className="mining-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.6 }}
              >
                 <div className="mining-card-inner">

    <h3>{item.cardTitle.toUpperCase()}</h3>

    <p className="section-text">
      {item.cardDescription}
    </p>

  </div>
              </motion.div>

            </motion.div>

          </SwiperSlide>
        ))}
      </Swiper>

      {/* PAGINATION */}
      <motion.div
        className="mining-pagination"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
      />

    </div>
  </div>
</section>

      {/**LONG TERM SUSTAINABLE DEVELOPMENT SECTION */}
      <section className="video-section container section-special">

 

  <motion.div
    className="content-wrapper"
    variants={container}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    <motion.p className="section-subheading" variants={fadeUp}>
Care for People and the Planet
    </motion.p>

    <motion.h2 className="section-heading" variants={fadeUp}>
     Driving Long-Term Sustainable Development
    </motion.h2>

    <motion.p className="section-text" variants={fadeUp}>
     Environmental and social sustainability issues are playing an increasingly important role in the industry, which is committed to redefining objectives, strategies and tools, and to directly involving people. At <b className="bold">Iris Impulse India Pvt. Ltd.</b>, Kutch, Gujarat, India, we are committed to promoting long-term sustainable development across all aspects of our operations. By combining responsible mining, eco-friendly processing, and community initiatives, we ensure that growth, environmental stewardship, and social responsibility go hand in hand. Our approach focuses on creating lasting value for industries, local communities, and the environment, reflecting our dedication to ethical and sustainable business practices.
    </motion.p>
    <motion.p className="section-text" variants={fadeUp}>
  Through continuous innovation, resource optimization, and responsible operational practices, we aim to reduce environmental impact while enhancing efficiency and product quality. Our sustainability-driven initiatives support cleaner production methods, employee well-being, and community development, helping us build a stronger and more responsible future for generations to come.
</motion.p>
  </motion.div>

   <motion.div
    className="video-wrapper"
    variants={fadeLeft}
    initial="hidden"
    whileInView="visible"
   iewport={{ once: true, margin: "-50px" }}
  >
    <img src={heroImg2} alt="Driving Long-Term Sustainable Development | Iris Impulse India Pvt. Ltd." />
  </motion.div>
</section>

      {/**SUSTAINABILITY EFFORTS SECTION */}
        <section className="mission-section">
       <div className="container">
     
         <motion.h2
           className="section-heading"
           variants={fadeUp}
           initial="hidden"
           whileInView="visible"
           viewport={{ once: true, amount: 0.3 }}
         >
People at the Heart of Sustainability Efforts
         </motion.h2>
     
         <motion.div
           className="mission-grid csr-grid"
           variants={staggerContainer}
           initial="hidden"
           whileInView="visible"
           viewport={{ once: true, amount: 0.2 }}
         >
     
           {/* Vision Card */}
           <motion.div
             className="mission-card-special  card-2"
             variants={fadeUp}
             whileHover={{
               y: -15,
               transition: { duration: 0.1 },
             }}
           >
             <div className="mission-card-special-inner">
            <img src={sustainabilityIcon1} alt="Working Together for a Sustainable Future | Iris Impulse India Pvt. Ltd."></img>
             <h3 className="card-heading">Working Together for a Sustainable Future
</h3>
     
             <p className="section-text">
              We believe that raising awareness and engagement — from our employees to the communities around us — is key to creating lasting positive impact. As a company, we embrace our responsibility to lead the transition toward more sustainable production. At the same time, we are committed to investing in the training and wellbeing of people both inside and outside our organization, fostering a corporate culture rooted in environmental stewardship and social respect. 
             </p>
             </div>
           </motion.div>
     
           {/* Mission Card */}
           <motion.div
             className="mission-card-special"
             variants={fadeUp}
             whileHover={{
               y: -15,
               transition: { duration: 0.1 },
             }}
           >
             <div className="mission-card-special-inner">
            <img src={sustainabilityIcon2} alt="HSN Goal with ZERO Injuries | Iris Impulse"></img>
             <h3 className="card-heading">HSN Goal with ZERO Injuries
</h3>
     
             <p className="section-text">
               Occupational health and safety are not only our duty — they are a shared value across our entire corporate community. We are committed to building a sustainable future where safety, sustainability, innovation, and integrity are fundamental to our business success.For many years, we have been following a continuous path of improvement, grounded in training, awareness, and prevention, with one clear objective: to achieve zero workplace injuries.Together, we strive to create a culture where every action and decision contributes to a safer, healthier, and more responsible workplace for all.


             </p>
             </div>
           </motion.div>
     
         </motion.div>
       </div>
     </section>

            {/**OUR ENVIRONMENTAL COMMITMENTS SECTION */}
              <section className="offers-section env-section">
                     <div className="container">
             
             
               {/* HEADING */}
               <motion.h2
                 className="section-heading"
                 variants={fadeUp}
                 initial="hidden"
                 whileInView="visible"
                 viewport={{ once: true }}
               >
Our Environmental Commitments
               </motion.h2>
             
               {/* GRID */}
               <motion.div
                 className="offers-grid"
                 variants={container}
                 initial="hidden"
                 whileInView="visible"
                 viewport={{ once: true }}
               >
                 {envCommitments.map((item) => (
                   <motion.div
                     className="offer-card"
                     key={item.title}
                     variants={cardAnim}
                   >
                     <motion.div
                       className="card-inner"
                       whileHover={{ y: -8 }}
                     >
                       <img src={item.icon} alt={`${item.pointTitle} | Iris Impulse India Pvt. Ltd.`}></img>
                       <h3 className="card-heading">{item.pointTitle}</h3>
                       <p>{item.pointDesc}</p>
                     </motion.div>
                   </motion.div>
             
                 ))}
               </motion.div>
             </div>
             </section>

          {/**BUILDING A BETTER FUTURE... SECTION */}
    <Gallery
  heading="Building a Better Future, Together"
  description="We, at Iris are committed to Manufacture, Sale & Export of Various Grades of Bentonite & Other Minerals conforming to Customer Requirements & Meeting Product Specifications for Highest Customer Satisfaction in time, every time abiding regulations considering the external & internal issues and needs & expectations of interested parties."
  images={csrGalleryData}
/>

            
    {/**CTA SECTION */}
    <Cta />

    {/**CERTIFICATES SECTION */}
    <Certificates/>

    {/**CONTACT FORM SECTION */}
    <ContactSection />

        </>
    )
}
export default Csr;